import { render } from "./PendingCredits.vue?vue&type=template&id=4add5052&scoped=true&ts=true"
import script from "./PendingCredits.vue?vue&type=script&lang=ts"
export * from "./PendingCredits.vue?vue&type=script&lang=ts"

import "./PendingCredits.vue?vue&type=style&index=0&id=4add5052&scoped=true&lang=sass"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4add5052"]])

export default __exports__